import i18n from "i18n/i18n";
import { escapeRegExp } from "lodash";
import * as $ from "jquery";
import { ReactComponent as BrokenClock } from "assets/Svgs/BrokenClock.svg";
import { ReactComponent as Flash } from "assets/Svgs/Flash.svg";
import { ReactComponent as Flick } from "assets/Svgs/FlickCursor.svg";
import mime from "mime";
import moment from "moment";

export function truncateWithEllipses(text, max) {
  try {
    return text.substr(0, max - 1) + (text.length > max ? "…" : "");
  } catch (e) {
    // console.error(e);
  }
}

export const categoryItems = [
  {
    id: "guidelines",
    category: { de: "Anleitungen/Anweisungen", en: "Instructions/guidelines" },
    docsCount: 0,
  },
  { id: "reports", category: { de: "Berichte", en: "Reports" }, docsCount: 0 },
  {
    id: "certificates",
    category: { de: "Zertifikate", en: "Certificates" },
    docsCount: 0,
  },
  {
    id: "documentation",
    category: { de: "Produkt-Dokumentation", en: "Product documentation" },
    docsCount: 0,
  },
];

/* Maintenance Task Repetitions & Reminders */

export const repetions = (lang) => {
  return [
    {
      key: "onetime",
      value: "",
      label: i18n(lang)?.maintenance_repetition_once,
    },

    { key: "1w", value: "1", label: i18n(lang)?.maintenance_repetition_week },

    { key: "1m", value: "1", label: i18n(lang)?.maintenance_repetition_month },
    { key: "3m", value: "3", label: i18n(lang)?.maintenance_repetition_months },
    { key: "6m", value: "6", label: i18n(lang)?.maintenance_repetition_months },
    { key: "1y", value: "1", label: i18n(lang)?.maintenance_repetition_yearly },
    {
      key: "18m",
      value: "18",
      label: i18n(lang)?.maintenance_repetition_months,
    },
    {
      key: "24m",
      value: "24",
      label: i18n(lang)?.maintenance_repetition_months,
    },
  ];
};

export const reminders = (lang) => {
  return [
    { key: "2d", value: "2", label: i18n(lang)?.maintenance_reminder_days },
    { key: "1w", value: "1", label: i18n(lang)?.maintenance_reminder_Week },
    { key: "2w", value: "2", label: i18n(lang)?.maintenance_reminder_Weeks },
    { key: "1m", value: "1", label: i18n(lang)?.maintenance_reminder_month },
  ];
};

export const getReminderItems = (repitionValue,lang) => {
  let reminderItems;

  switch (repitionValue) {
    case "1w":
      reminderItems = [
        { key: "2d", value: "2", label: i18n(lang)?.maintenance_reminder_days },
      ];
      break;
    case "2w":
      reminderItems = [
        { key: "2d", value: "2", label: i18n(lang)?.maintenance_reminder_days },
        { key: "1w", value: "1", label: i18n(lang)?.maintenance_reminder_Week },
      ];
      break;
    case "1m":
      reminderItems = [
        { key: "2d", value: "2", label: i18n(lang)?.maintenance_reminder_days },
        { key: "1w", value: "1", label: i18n(lang)?.maintenance_reminder_Week },
        {
          key: "2w",
          value: "2",
          label: i18n(lang)?.maintenance_reminder_Weeks,
        },
      ];
      break;
    default:
      reminderItems = reminders(lang);
  }

  return reminderItems;
};

export function GetRepetitionValue(key, lang) {
  let repetitionString = "";
  repetions(lang).map((repetion) => {
    if (repetion.key === String(key)) {
      repetitionString = repetion.value + " " + repetion.label;
    }
  });
  return repetitionString;
}

export function GetReminderValue(key, lang) {
  let reminderString = "";
  reminders(lang).map((reminder) => {
    if (reminder.key === String(key)) {
      reminderString = reminder.value + " " + reminder.label;
    }
  });
  return reminderString;
}

export const getHighlightedText = (text, highlight) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, "gi");
  const parts = text?.split(regex);
  return (
    <span>
      {parts &&
        parts
          .filter((part) => part)
          .map((part, i) =>
            regex.test(part) ? (
              <span
                style={{ color: "var(--primary-color)", fontWeight: "bold" }}
                key={i}
              >
                {part}
              </span>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
    </span>
  );
};

export const getSvgByReportConfigType = (triggertype) => {
  switch (triggertype) {
    case "time":
      return <BrokenClock />;
    case "event":
      return <Flash />;
    case "manual":
      return <Flick />;
    default:
      return <BrokenClock />;
  }
};

export const docs_enum = "application/*,text/*";
export const images_enum = "image/*";
export const videos_enum = "video/*";

export const allow_docs_mimetypes = ["application", "text"];

export const allow_images_mimetypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
  "image/svg+xml",
  "image/x-icon",
  "image/heif",
  "image/heic",
];

export const allow_videos_mimetypes = ["video/*"];

export const getFileExtention = (type) => {
  return mime.getExtension(type);
};

export const borderColors = [
  "#FF3D00",
  "#FFB300",
  "#AEAEAE",
  "#AEAEAE",
  "#AEAEAE",
  "#AEAEAE",
  "#8E24AA",
  "#FFB300",
];

export const GetTitleSafely = (notification) => {
  // since the notification-JSON differs often and sometimes has language variants and sometimes it hasn't, the title must be safely defined:
  let notificationTitle = "";

  return notificationTitle;
};

/* Notification States */
const notificationStates = [
  { code: 0, value: "open", label: i18n.state_open },
  { code: 1, value: "indiscussion", label: i18n.state_in_discussion },
  { code: 2, value: "closed", label: i18n.state_closed },
];

export const StatusType = (type) => {
  let str = "";
  notificationStates.map((statusType) => {
    if (statusType.code === Number(type)) {
      return (str = statusType.label);
    }
  });
  return str;
};

export const isValidEmail = (emailAdress) => {
  let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailAdress.match(regex)) return true;
  else return false;
};


export const getIntervalsInMs = (repitition) => {
  if (repitition === "1w") return 7 * 24 * 60 * 60 * 1000;
  else if (repitition === "2w") return 14 * 24 * 60 * 60 * 1000;
  else if (repitition === "1m")
    return moment()
      .add(1, "months")
      .diff(moment());
  else if (repitition === "2m")
    return moment()
      .add(2, "months")
      .diff(moment());
  else if (repitition === "3m")
    return moment()
      .add(3, "months")
      .diff(moment());
  else if (repitition === "6m")
    return moment()
      .add(6, "months")
      .diff(moment());
      else if (repitition === "1y")
      return moment()
        .add(12, "months")
        .diff(moment());
  else if (repitition === "12m")
    return moment()
      .add(12, "months")
      .diff(moment());
  else if (repitition === "18m")
    return moment()
      .add(18, "months")
      .diff(moment());
  else if (repitition === "24m")
    return moment()
      .add(24, "months")
      .diff(moment());
  else if (repitition === "36m")
    return moment()
      .add(36, "months")
      .diff(moment());
  else if (repitition === "48m")
    return moment()
      .add(48, "months")
      .diff(moment());
  else{
    return 0;
  }
  /* return {
    twoDays: 2 * 24 * 60 * 60 * 1000,
    oneWeek: 7 * 24 * 60 * 60 * 1000,
    twoWeeks: 14 * 24 * 60 * 60 * 1000,
    oneMonth: moment().add(1, 'months').diff(moment()),
  }; */
};